var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.667 73.667H11.3962C9.70566 73.667 8.33366 75.039 8.33366 76.7295C8.33366 78.42 9.70566 79.792 11.3962 79.792H75.7087C77.8728 79.792 79.792 77.8728 79.792 75.7087V11.3962C79.792 9.70566 78.42 8.33366 76.7295 8.33366C75.039 8.33366 73.667 9.70566 73.667 11.3962V73.667ZM69.5837 4.25033C69.5837 2.29849 68.0361 0.166992 65.5003 0.166992H4.25033C1.71866 0.166992 0.166992 2.28624 0.166992 4.25033V65.5003C0.166992 68.0361 2.29033 69.5837 4.25033 69.5837H65.5003C67.4522 69.5837 69.5837 68.0361 69.5837 65.5003V4.25033ZM6.29199 6.29199H63.4587V63.4587H6.29199V6.29199ZM31.8128 31.8128H19.5628C17.8723 31.8128 16.5003 33.1848 16.5003 34.8753C16.5003 36.5658 17.8723 37.9378 19.5628 37.9378H31.8128V50.1878C31.8128 51.8783 33.1848 53.2503 34.8753 53.2503C36.5658 53.2503 37.9378 51.8783 37.9378 50.1878V37.9378H50.1878C51.8783 37.9378 53.2503 36.5658 53.2503 34.8753C53.2503 33.1848 51.8783 31.8128 50.1878 31.8128H37.9378V19.5628C37.9378 17.8723 36.5658 16.5003 34.8753 16.5003C33.1848 16.5003 31.8128 17.8723 31.8128 19.5628V31.8128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.bcae808fdbeaf7e9e57b1874d8fbfc1a.svg";
export { ForwardRef as ReactComponent };